import React from "react";
import styles from "./RsvpGuestAddress.module.css";
import { Col, Layout } from "antd";
import Header from "../../../../components/header/Header";
import bgcImage from "../../../../assets/bgcimage.png";
import Rsvp from "../../../../assets/rsvp8.png";
import TextComponent from "../../../../components/textComponent/TextComponent";
import SubmitBotton from "../../../../components/submitButton/SubmitButton";
import { BiSolidChevronRightCircle } from "react-icons/bi";
import { FaLocationDot } from "react-icons/fa6";
import { BiSolidTimeFive } from "react-icons/bi";
import GoogleMap from "../../../../components/GoogleMap/GoogleMap";
import { useLocation, useNavigate } from "react-router-dom";
import { ClockIcon, LocIcon } from "../../../../components/icons/Icons";
import { useSelector } from "react-redux";
import moment from "moment";

const RsvpGuestAddress = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const rsvpData = useSelector(
    (state) => state?.GuestReducer?.guestRsvpDetails
  );
  console.log(rsvpData);
  return (
    <div className={styles.mainContainer}>
      <Layout className="site-layout">
        <Header
          mainHeader={styles.headerColor}
          isProfile={true}
          title={"RSVP"}
          style={{ padding: 0, background: "var(--white-color)", height: 85 }}
          onBackClick={() => navigate(-1)}
        />
      </Layout>
      <div className={styles.mainDiv}>
        <div className={styles.innerDiv}>
          <div className={styles.innerDiv2}>
            <TextComponent textClass={styles.title} text="Address" />
            <div className={styles.col}>
              <LocIcon size={30} color={"black"} />
              <TextComponent
                textClass={styles.text1}
                text={
                  rsvpData?.address?.address
                    ? rsvpData?.address?.address
                    : rsvpData?.event?.address
                }
              />
            </div>
            <div className={styles.col}>
              <ClockIcon size={30} color={"black"} />
              <TextComponent
                textClass={styles.text1}
                text={moment(rsvpData?.event?.start_time).format("h:mm A")}
              />
            </div>
            <GoogleMap
              style={{
                height: "30vh",
              }}
              className={styles.map}
              lat={
                rsvpData?.address?.latitude
                  ? rsvpData?.address?.latitude
                  : rsvpData?.event?.latitude
              }
              lng={
                rsvpData?.address?.longitude
                  ? rsvpData?.address?.longitude
                  : rsvpData?.event?.longitude
              }
            />
            <BiSolidChevronRightCircle
              className={styles.con1}
              cursor={"pointer"}
              size={30}
              onClick={() => navigate("/rsvp/rsvpGuestTable", { state: state })}
            />
          </div>
        </div>
        <div className={styles.imgContainer}>
          <img className={styles.innerImg} src={Rsvp} />
        </div>
      </div>
    </div>
  );
};

export default RsvpGuestAddress;
